<template>
    <router-link class="logo" :to="$i18nRoute({ name: 'home'})">
      <h1>Bleeding Edge</h1>
    </router-link>
</template>

<script>

export default {
  name: 'Logo',
};
</script>

<style lang="scss">
  .logo {
    background: transparent url('~@/assets/images/logo.png') no-repeat center center;
    font-size: 0;
    background-size: cover;
    display: block;
    width: 60px;
    height: 41px;
    
    @include bp($bp--m) {
      width: 100px;
      height: 69px;
    }

    @include bp($bp--xl) {
      width: 120px;
      height: 83px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/Logo.vue